import React from 'react';

import { EnvItemBoolean, EnvList, HiddenSection } from 'pages/diagnostics/components';
import { useAllFlags } from 'utils/launchdarkly'

// TODO: currently displaying all flags as boolean
//       even for more complex flag types.
//       should show values based on type of flag
const LDFlagsContent = () => {
  const allFlags = useAllFlags();
  return (
    <EnvList
      data={allFlags}
      renderItem={(key, value) => <EnvItemBoolean key={key} envKey={key} value={value} />}
    />
  );
};

export const LDFlags = () => (
  <HiddenSection title="LaunchDarkly Flags" content={<LDFlagsContent />} />
);
